import {
  BOOKLET_SECTION_FRAGMENT_VOTE,
  BOOKLET_SECTION_FRAGMENT_VOTE_DELETE,
  BOOKLET_SECTION_FRAGMENT_VOTE_SUCCESS,
  BOOKLET_SECTION_FRAGMENT_VOTE_FAILURE,
  BOOKLET_SECTION_FRAGMENT_VOTE_DELETE_SUCCESS,
  BOOKLET_SECTION_FRAGMENT_VOTE_DELETE_FAILURE,
} from '../reducers/booklet.reducer';
import {
  LOADING_DATA_FINISHED,
  LOADING_DATA_START,
} from '../reducers/loading.reducer';
import { call, put, takeLatest } from 'redux-saga/effects';
import { voteApi } from '../services';
import { handleError } from './helper';

function* voteRequest({
  payload: {
    bookletId,
    sectionId,
    sectionIndex,
    fragment,
    fragmentIndex,
    vote,
    childIndex,
    token,
  },
}) {
  try {
    yield put({ type: LOADING_DATA_START });

    const body = {
      vote: {
        score: vote,
      },
    };

    let response;

    if (token) {
      response = !fragment.currentUserVote
        ? yield call(voteApi.addShareVote, {
            body: { vote: { ...body.vote, fragmentId: fragment.id } },
            token,
          })
        : yield call(voteApi.updateShareVote, {
            body,
            token,
            fragmentId: fragment.id,
          });
    } else {
      response = !fragment.currentUserVote
        ? yield call(voteApi.addVote, {
            body,
            bookletId,
            sectionId,
            fragmentId: fragment.id,
          })
        : yield call(voteApi.updateVote, {
            body,
            bookletId,
            sectionId,
            fragmentId: fragment.id,
          });
    }

    yield put({
      type: BOOKLET_SECTION_FRAGMENT_VOTE_SUCCESS,
      payload: { data: response.data, sectionIndex, fragmentIndex, childIndex },
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({
      type: BOOKLET_SECTION_FRAGMENT_VOTE_FAILURE,
      payload: message,
    });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* deleteVoteRequest({
  payload: {
    bookletId,
    sectionId,
    sectionIndex,
    fragment,
    fragmentIndex,
    childIndex,
    token,
  },
}) {
  try {
    yield put({ type: LOADING_DATA_START });

    if (token) {
      yield call(voteApi.deleteShareVote, {
        fragmentId: fragment.id,
        token,
      });
    } else {
      yield call(voteApi.deleteVote, {
        bookletId,
        sectionId,
        fragmentId: fragment.id,
      });
    }

    yield put({
      type: BOOKLET_SECTION_FRAGMENT_VOTE_DELETE_SUCCESS,
      payload: { sectionIndex, fragmentIndex, childIndex },
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({
      type: BOOKLET_SECTION_FRAGMENT_VOTE_DELETE_FAILURE,
      payload: message,
    });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

export function* vote() {
  yield takeLatest(BOOKLET_SECTION_FRAGMENT_VOTE, voteRequest);
}
export function* deleteVote() {
  yield takeLatest(BOOKLET_SECTION_FRAGMENT_VOTE_DELETE, deleteVoteRequest);
}



// WEBPACK FOOTER //
// ./src/sagas/vote.saga.js